export default async ({ store, redirect }) => {
  if (!store.state.global.loggedIn) {
    redirect('/login');
  }
};
